<template>
  <el-dialog title="创建福利卡"
             :visible.sync="dialogVisible"
             width="768px"
             :before-close="handleClose">
    <div class="main">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="140px"
               class="demo-ruleForm">
        <el-form-item label="福利卡名称："
                      prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="面值："
                      prop="amount">
          <el-input v-model="ruleForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="发行数："
                      prop="number">
          <el-input v-model="ruleForm.number"></el-input>
        </el-form-item>
        <el-form-item label="类型："
                      prop="category">
          <el-radio-group v-model="ruleForm.category">
            <!-- <el-radio label="1">员工内部卡</el-radio> -->
            <el-radio label="8">通用福利卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期："
                      prop="date">
          <el-date-picker v-model="ruleForm.date"
                          style="width: 100%"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :picker-options="expireTimeOption">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="图片"
                      prop="img_id">
          <el-radio-group v-model="ruleForm.img_id">
            <el-radio label="27780">
              <el-image src="https://static.xinfushenghuo.cn/publics/imgs/updatas/20220125//20220125103552426.png"
                        :z-index="2000"
                        :preview-src-list="srcList"
                        @click.native="showView('https://static.xinfushenghuo.cn/publics/imgs/updatas/20220125//20220125103552426.png')"
                        style="width: 200px"> </el-image>
            </el-radio>
            <el-radio label="27779">
              <el-image src="https://static.xinfushenghuo.cn/publics/imgs/updatas/20220125//20220125103535944.png"
                        :z-index="2000"
                        :preview-src-list="srcList"
                        @click.native="showView('https://static.xinfushenghuo.cn/publics/imgs/updatas/20220125//20220125103535944.png')"
                        style="width: 200px"> </el-image>
            </el-radio>
            <el-radio label="27778">
              <el-image src="https://static.xinfushenghuo.cn/publics/imgs/updatas/20220125//20220125103518678.png"
                        :z-index="2000"
                        :preview-src-list="srcList"
                        @click.native="showView('https://static.xinfushenghuo.cn/publics/imgs/updatas/20220125//20220125103518678.png')"
                        style="width: 200px;margin-top:20px"> </el-image>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary"
                 @click="onSubmit">确认创建</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data () {
    return {
      expireTimeOption: {
        disabledDate (date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      srcList: [],

      dialogVisible: false,
      ruleForm: {
        title: "",
        amount: "",
        number: "",
        category: "8",
        date: [],
        img_id: "27780",
      },
      rules: {
        title: [{ required: true, message: "请输入福利卡名称", trigger: "blur" }],
        amount: [{ required: true, message: "请输入面值", trigger: "blur" }],
        number: [{ required: true, message: "请输入发行数", trigger: "blur" }],
        category: [{ required: true, message: "请选择类型", trigger: "change" }],
        date: [{ required: true, message: "请选择有效期", trigger: "change" }],
        img_id: [{ required: true, message: "请选择图片", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  methods: {
    ...mapActions({
      couponsCreate: "detect/couponsCreate",
    }),
    showView (val) {
      this.srcList = [];
      this.srcList.push(val);
    },
    cahnge5 (val) {
      alert(val)
    },
    onSubmit () {
      let { title, amount, number, category, date, img_id } = this.ruleForm;
      let params = {
        token: this.getToken,
        title,
        amount,
        number,
        category,
        able_start_time: date ? date[0] : null,
        able_end_time: date ? date[1] : null,
        img_id,
      };
      this.couponsCreate(params).then(({ data }) => {
        console.log(data);
        if (data.code == 1) {
          this.$message.success("创建成功");
          this.handleClose();
          this.$emit("init");
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleClose () {
      this.dialogVisible = false;
      this.ruleForm = {
        title: "",
        amount: "",
        number: "",
        category: "8",
        date: [],
      };
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
}
</style>